// Canonical stage color language — single source for Dashboard, Pipeline, badges, charts.
// Semantic: Repéré neutral · Contacté blue · En discussion amber · Mandat signé green · Placé teal.
export const STAGE_STYLE = {
  "Repéré": {
    col: "bg-zinc-100/80 border-zinc-200/80 dark:bg-white/[0.025] dark:border-white/[0.06]",
    over: "bg-zinc-200/80 border-zinc-300 dark:bg-white/[0.06] dark:border-white/[0.16]",
    dot: "bg-zinc-400 dark:bg-zinc-400",
  },
  "Contacté": {
    col: "bg-blue-50/80 border-blue-100 dark:bg-blue-500/[0.05] dark:border-blue-400/[0.12]",
    over: "bg-blue-100/90 border-blue-200 dark:bg-blue-500/[0.11] dark:border-blue-400/[0.3]",
    dot: "bg-blue-500",
  },
  "En discussion": {
    col: "bg-orange-50/80 border-orange-100 dark:bg-orange-500/[0.05] dark:border-orange-400/[0.14]",
    over: "bg-orange-100/90 border-orange-200 dark:bg-orange-500/[0.11] dark:border-orange-400/[0.32]",
    dot: "bg-amber-500",
  },
  "Mandat signé": {
    col: "bg-green-50/80 border-green-100 dark:bg-green-500/[0.05] dark:border-green-400/[0.12]",
    over: "bg-green-100/90 border-green-200 dark:bg-green-500/[0.11] dark:border-green-400/[0.3]",
    dot: "bg-green-500",
  },
  "Placé": {
    col: "bg-teal-50/80 border-teal-100 dark:bg-teal-500/[0.05] dark:border-teal-400/[0.12]",
    over: "bg-teal-100/90 border-teal-200 dark:bg-teal-500/[0.11] dark:border-teal-400/[0.3]",
    dot: "bg-teal-500",
  },
};

// KpiCard tone key per stage (maps to KpiCard TONES).
export const STAGE_TONE = {
  "Repéré": "neutral",
  "Contacté": "info",
  "En discussion": "warning",
  "Mandat signé": "success",
  "Placé": "teal",
};
